import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { integrationService } from '../services/integrations.service';

/**
 * Tipo para los proveedores autorizados obtenidos del método `getAuthorizedProviders`.
 */
export interface AuthorizedProvider {
    _id: string;
    name: string;
    available: boolean;
    icon: string;
    authorization: {
        id: string;
        completed: boolean;
    };
}

/**
 * Hook para obtener la lista de proveedores autorizados para el usuario actual.
 *
 * @returns Los proveedores autorizados y el estado de la consulta.
 */
export const useGetAuthorizedProviders = (): UseQueryResult<AuthorizedProvider[], Error> => {
    return useQuery<AuthorizedProvider[], Error>({
        queryKey: ['authorizedProviders'], // Clave única para la consulta
        queryFn: async () => {
            const authorizedProviders = await integrationService.getAuthorizedProviders();
            return authorizedProviders;
        },
    });
};
